const HighSalaryTabDesktopIcon = () => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_20351_814508)">
			<path
				d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
				fill="white"
			/>
			<path
				d="M13.4086 22.5285L9.51293 24.6666C9.46275 24.6941 9.43462 24.7497 9.44212 24.8064L10.1665 30.2932C10.1756 30.3622 10.2344 30.4138 10.304 30.4138H10.8322L20.6098 31.6904C21.2979 31.7802 21.9947 31.609 22.5629 31.2106L32.2351 24.4275C32.7241 24.0846 32.9173 23.4532 32.7041 22.8954C32.434 22.1887 31.6209 21.8599 30.9354 22.1801L22.6921 26.0311C22.6581 26.047 22.6266 26.005 22.6513 25.9768L24.4162 23.9654C25.1254 23.1573 24.293 21.9355 23.2814 22.2996L20.9402 23.1422C20.3048 23.3709 19.6078 23.3601 18.9798 23.1119L16.9423 22.3065C15.7901 21.851 14.4948 21.9324 13.4086 22.5285Z"
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={1.08889}
			/>
			<path
				d="M17.7112 25.6025C17.7112 25.6025 18.752 25.939 19.4365 26.0811C19.8379 26.1645 20.0633 26.221 20.4717 26.2547C20.8746 26.2881 21.105 26.2981 21.5069 26.2547C21.8485 26.2179 22.1675 26.1489 22.3696 26.0811C22.5717 26.0133 22.6851 25.9753 22.8872 25.9075"
				stroke="#190A28"
				strokeWidth={1.08889}
				strokeLinecap="round"
			/>
			<rect
				width={3.89866}
				height={10.4609}
				rx={0.693914}
				transform="matrix(0.999984 -0.00558538 0.00557729 0.999984 6.93347 21.6729)"
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={1.08889}
			/>
			<ellipse
				cx={8.88269}
				cy={23.7905}
				rx={0.649776}
				ry={0.653807}
				fill="#190A28"
			/>
			<rect
				x={12.0668}
				y={8.33385}
				width={15.8667}
				height={10.2667}
				rx={1.4}
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M22.1778 10.5001H20.7291C21.0786 10.6749 21.3137 10.9756 21.4344 11.4022H22.1778V12.1679H21.5107C21.4853 12.6085 21.3614 12.9756 21.139 13.2693C20.9229 13.563 20.6021 13.7938 20.1764 13.9616L21.6334 16.3526H20.2133L19.0136 14.1819H17.8223V13.3113H18.9755C19.3694 13.3113 19.6681 13.2239 19.8714 13.049C20.0747 12.8742 20.1922 12.5805 20.224 12.1679H17.8223V11.4022H20.1764C20.1128 11.1155 19.9762 10.9092 19.7665 10.7833C19.5569 10.6505 19.2709 10.584 18.9088 10.584H17.8223V9.73438H22.1778V10.5001Z"
				fill="#190A28"
			/>
			<circle cx={14.5554} cy={13.6231} r={1.08889} fill="#190A28" />
			<circle cx={25.4446} cy={13.6231} r={1.08889} fill="#190A28" />
		</g>
		<defs>
			<clipPath id="clip0_20351_814508">
				<rect width={40} height={40} fill="white" />
			</clipPath>
		</defs>
	</svg>
);
const HighSalaryTabSelectedDesktopIcon = () => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_20351_814463)">
			<path
				d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
				fill="#B6ECEC"
			/>
			<g clipPath="url(#clip1_20351_814463)">
				<path
					d="M13.4085 22.5285L9.51281 24.6666C9.46262 24.6941 9.4345 24.7497 9.44199 24.8064L10.1663 30.2932C10.1754 30.3622 10.2343 30.4138 10.3039 30.4138H10.832L20.6097 31.6904C21.2978 31.7802 21.9946 31.609 22.5628 31.2106L32.235 24.4275C32.724 24.0846 32.9172 23.4532 32.704 22.8954C32.4339 22.1887 31.6208 21.8599 30.9353 22.1801L22.692 26.0311C22.658 26.047 22.6264 26.005 22.6512 25.9768L24.4161 23.9654C25.1252 23.1573 24.2929 21.9355 23.2812 22.2996L20.94 23.1422C20.3046 23.3709 19.6077 23.3601 18.9797 23.1119L16.9422 22.3065C15.7899 21.851 14.4947 21.9324 13.4085 22.5285Z"
					fill="#E7F9F9"
					stroke="#190A28"
					strokeWidth={1.08889}
				/>
				<path
					d="M17.7109 25.6025C17.7109 25.6025 18.7518 25.939 19.4363 26.0811C19.8377 26.1645 20.063 26.221 20.4715 26.2547C20.8744 26.2881 21.1047 26.2981 21.5067 26.2547C21.8483 26.2179 22.1672 26.1489 22.3693 26.0811C22.5715 26.0133 22.6848 25.9753 22.887 25.9075"
					stroke="#190A28"
					strokeWidth={1.08889}
					strokeLinecap="round"
				/>
				<rect
					width={3.89866}
					height={10.4609}
					rx={0.693914}
					transform="matrix(0.999984 -0.00558538 0.00557729 0.999984 6.93335 21.6729)"
					fill="#E7F9F9"
					stroke="#190A28"
					strokeWidth={1.08889}
				/>
				<ellipse
					cx={8.88244}
					cy={23.7905}
					rx={0.649776}
					ry={0.653807}
					fill="#190A28"
				/>
			</g>
			<rect
				x={12.0668}
				y={8.33385}
				width={15.8667}
				height={10.2667}
				rx={1.4}
				fill="url(#paint0_linear_20351_814463)"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M22.1778 10.5001H20.7291C21.0786 10.6749 21.3137 10.9756 21.4344 11.4022H22.1778V12.1679H21.5107C21.4853 12.6085 21.3614 12.9756 21.139 13.2693C20.9229 13.563 20.6021 13.7938 20.1764 13.9616L21.6334 16.3526H20.2133L19.0136 14.1819H17.8223V13.3113H18.9755C19.3694 13.3113 19.6681 13.2239 19.8714 13.049C20.0747 12.8742 20.1922 12.5805 20.224 12.1679H17.8223V11.4022H20.1764C20.1128 11.1155 19.9762 10.9092 19.7665 10.7833C19.5569 10.6505 19.2709 10.584 18.9088 10.584H17.8223V9.73438H22.1778V10.5001Z"
				fill="white"
			/>
			<circle cx={14.5554} cy={13.6231} r={1.08889} fill="white" />
			<circle cx={25.4446} cy={13.6231} r={1.08889} fill="white" />
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_20351_814463"
				x1={6.17355}
				y1={11.4849}
				x2={11.9405}
				y2={24.8754}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00CFDE" />
				<stop offset={1} stopColor="#05A660" />
			</linearGradient>
			<clipPath id="clip0_20351_814463">
				<rect width={40} height={40} fill="white" />
			</clipPath>
			<clipPath id="clip1_20351_814463">
				<rect width={28} height={13} fill="white" transform="translate(6 21)" />
			</clipPath>
		</defs>
	</svg>
);
const HighSalaryTabMobileIcon = () => (
	<svg
		width={48}
		height={48}
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45Z"
			fill="#E7F9F9"
		/>
		<path
			d="M16.9379 26.7088L12.764 28.9996C12.7102 29.0291 12.6801 29.0886 12.6881 29.1495L13.4642 35.0281C13.474 35.1021 13.537 35.1574 13.6116 35.1574H14.1774L24.6535 36.5251C25.3908 36.6214 26.1373 36.438 26.7461 36.0111L37.1092 28.7435C37.6331 28.3761 37.8402 27.6996 37.6117 27.1019C37.3223 26.3448 36.4511 25.9925 35.7167 26.3355L26.8845 30.4616C26.8481 30.4787 26.8143 30.4337 26.8409 30.4034L28.7318 28.2484C29.4916 27.3825 28.5998 26.0734 27.5159 26.4635L25.0074 27.3664C24.3267 27.6114 23.5799 27.5998 22.9071 27.3338L20.7241 26.4709C19.4895 25.9829 18.1017 26.0701 16.9379 26.7088Z"
			fill="#E7F9F9"
			stroke="#190A28"
			strokeWidth={1.16667}
		/>
		<path
			d="M21.5479 30.0015C21.5479 30.0015 22.663 30.362 23.3964 30.5142C23.8265 30.6036 24.0679 30.6641 24.5056 30.7003C24.9373 30.736 25.184 30.7467 25.6147 30.7003C25.9807 30.6608 26.3224 30.5869 26.539 30.5142C26.7556 30.4416 26.877 30.4009 27.0936 30.3282"
			stroke="#190A28"
			strokeWidth={1.16667}
			strokeLinecap="round"
		/>
		<rect
			width={4.17713}
			height={11.2081}
			rx={0.743479}
			transform="matrix(0.999984 -0.00558538 0.00557729 0.999984 10 25.792)"
			fill="#E7F9F9"
			stroke="#190A28"
			strokeWidth={1.16667}
		/>
		<ellipse cx={12.0888} cy={28.0609} rx={0.696188} ry={0.700508} fill="#190A28" />
		<rect
			x={15.5}
			y={11.5}
			width={17}
			height={11}
			rx={1.5}
			fill="url(#paint0_linear_20485_86865)"
			stroke="#190A28"
		/>
		<path
			d="M26.3337 13.8204H24.7815C25.1559 14.0077 25.4078 14.3299 25.5372 14.787H26.3337V15.6074H25.6189C25.5916 16.0794 25.4589 16.4728 25.2206 16.7874C24.9891 17.1021 24.6454 17.3494 24.1892 17.5292L25.7503 20.0909H24.2288L22.9434 17.7652H21.667V16.8324H22.9026C23.3247 16.8324 23.6446 16.7387 23.8625 16.5514C24.0803 16.3641 24.2063 16.0494 24.2403 15.6074H21.667V14.787H24.1892C24.1212 14.4798 23.9748 14.2587 23.7501 14.1239C23.5255 13.9815 23.2191 13.9103 22.8311 13.9103H21.667V13H26.3337V13.8204Z"
			fill="white"
		/>
		<circle cx={18.1667} cy={17.1667} r={1.16667} fill="white" />
		<circle cx={29.8337} cy={17.1667} r={1.16667} fill="white" />
		<defs>
			<linearGradient
				id="paint0_linear_20485_86865"
				x1={9.18584}
				y1={14.8761}
				x2={15.3648}
				y2={29.223}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00CFDE" />
				<stop offset={1} stopColor="#05A660" />
			</linearGradient>
		</defs>
	</svg>
);
const HighSalaryTabSelectedMobileIcon = () => (
	<svg
		width={48}
		height={48}
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M44.5 24C44.5 35.3218 35.3218 44.5 24 44.5C12.6782 44.5 3.5 35.3218 3.5 24C3.5 12.6782 12.6782 3.5 24 3.5C35.3218 3.5 44.5 12.6782 44.5 24Z"
			fill="#E7F9F9"
			stroke="#00857C"
		/>
		<path
			d="M16.9379 26.7088L12.764 28.9996C12.7102 29.0291 12.6801 29.0886 12.6881 29.1495L13.4642 35.0281C13.474 35.1021 13.537 35.1574 13.6116 35.1574H14.1774L24.6535 36.5251C25.3908 36.6214 26.1373 36.438 26.7461 36.0111L37.1092 28.7435C37.6331 28.3761 37.8402 27.6996 37.6117 27.1019C37.3223 26.3448 36.4511 25.9925 35.7167 26.3355L26.8845 30.4616C26.8481 30.4787 26.8143 30.4337 26.8409 30.4034L28.7318 28.2484C29.4916 27.3825 28.5998 26.0734 27.5159 26.4635L25.0074 27.3664C24.3267 27.6114 23.5799 27.5998 22.9071 27.3338L20.7241 26.4709C19.4895 25.9829 18.1017 26.0701 16.9379 26.7088Z"
			fill="#E7F9F9"
			stroke="#190A28"
			strokeWidth={1.16667}
		/>
		<path
			d="M21.5479 30.0015C21.5479 30.0015 22.663 30.362 23.3964 30.5142C23.8265 30.6036 24.0679 30.6641 24.5056 30.7003C24.9373 30.736 25.184 30.7467 25.6147 30.7003C25.9807 30.6608 26.3224 30.5869 26.539 30.5142C26.7556 30.4416 26.877 30.4009 27.0936 30.3282"
			stroke="#190A28"
			strokeWidth={1.16667}
			strokeLinecap="round"
		/>
		<rect
			width={4.17713}
			height={11.2081}
			rx={0.743479}
			transform="matrix(0.999984 -0.00558538 0.00557729 0.999984 10 25.792)"
			fill="#E7F9F9"
			stroke="#190A28"
			strokeWidth={1.16667}
		/>
		<ellipse cx={12.0888} cy={28.0609} rx={0.696188} ry={0.700508} fill="#190A28" />
		<rect
			x={15.5}
			y={11.5}
			width={17}
			height={11}
			rx={1.5}
			fill="url(#paint0_linear_20485_87087)"
			stroke="#190A28"
		/>
		<path
			d="M26.3337 13.8204H24.7815C25.1559 14.0077 25.4078 14.3299 25.5372 14.787H26.3337V15.6074H25.6189C25.5916 16.0794 25.4589 16.4728 25.2206 16.7874C24.9891 17.1021 24.6454 17.3494 24.1892 17.5292L25.7503 20.0909H24.2288L22.9434 17.7652H21.667V16.8324H22.9026C23.3247 16.8324 23.6446 16.7387 23.8625 16.5514C24.0803 16.3641 24.2063 16.0494 24.2403 15.6074H21.667V14.787H24.1892C24.1212 14.4798 23.9748 14.2587 23.7501 14.1239C23.5255 13.9815 23.2191 13.9103 22.8311 13.9103H21.667V13H26.3337V13.8204Z"
			fill="white"
		/>
		<circle cx={18.1667} cy={17.1667} r={1.16667} fill="white" />
		<circle cx={29.8337} cy={17.1667} r={1.16667} fill="white" />
		<defs>
			<linearGradient
				id="paint0_linear_20485_87087"
				x1={9.18584}
				y1={14.8761}
				x2={15.3648}
				y2={29.223}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00CFDE" />
				<stop offset={1} stopColor="#05A660" />
			</linearGradient>
		</defs>
	</svg>
);
const HighSalaryTabIcon = {
	mobile: <HighSalaryTabMobileIcon />,
	mobileSelected: <HighSalaryTabSelectedMobileIcon />,
	desktop: <HighSalaryTabDesktopIcon />,
	desktopSelected: <HighSalaryTabSelectedDesktopIcon />,
};

export default HighSalaryTabIcon;
